export default function() {
  return !this.node();
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-selection/src/selection/empty.js
// module id = 433
// module chunks = 0